(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-mobile-accordion"] && !Shopify.designMode) return;
  try {
    
  this.addEventListener("DOMContentLoaded", () =>{
    const questions = document.querySelectorAll(".question")
    questions.forEach((question) => question.addEventListener("click", () =>{
  
        if(question.parentNode.classList.contains("acik")){
            question.parentNode.classList.toggle("acik")
        }
    else{
    questions.forEach(question => question.parentNode.classList.remove("acik"))
    question.parentNode.classList.add("acik")
        }

    }))
}) 

/*var acc = document.getElementsByClassName("answer");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-shopify-tabs-streamline-product-bringin"] && !Shopify.designMode) return;
  try {
    
  tabs = document.querySelectorAll('.tab');
    tabContents = document.querySelectorAll('.tab-content');


    tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
                console.log(this);
                console.log(this.dataset);

                contentId = this.dataset.contentId;
                content = document.getElementById(contentId);
                console.log(content);

                tabs.forEach(function(tab){
                        tab.classList.remove('active');
                });
                tabContents.forEach(function(content){
                        content.classList.remove('active');
                });

                

                this.classList.add('active');
                content.classList.add('active');
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-shopify-tabs"] && !Shopify.designMode) return;
  try {
    
  tabs = document.querySelectorAll('.tab');
    tabContents = document.querySelectorAll('.tab-content');


    tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
                console.log(this);
                console.log(this.dataset);

                contentId = this.dataset.contentId;
                content = document.getElementById(contentId);
                console.log(content);

                tabs.forEach(function(tab){
                        tab.classList.remove('active');
                });
                tabContents.forEach(function(content){
                        content.classList.remove('active');
                });

                

                this.classList.add('active');
                content.classList.add('active');
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-orc-adjusted"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'is-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'is-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'is-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero-section .hero-swiper').forEach((el) => {
    if (!el.swiper) {
      const swiper = new Swiper(el, {
        loop: true,
        effect: 'slide',
        speed: 800,
        allowTouchMove: true, 
        touchStartPreventDefault: false,
        // Attiviamo l'autoplay nativo di Swiper impostato a 5 secondi di base (per le immagini)
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.hero-pagination',
          clickable: true,
          type: 'bullets',
        },
        on: {
          init: function () {
            checkVideoAndAdjustAutoplay(this);
          },
          slideChange: function () {
            checkVideoAndAdjustAutoplay(this);
          }
        }
      });

      function checkVideoAndAdjustAutoplay(swiperInstance) {
        // Troviamo la slide corrente (funziona anche con i cloni del loop)
        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        if (!activeSlide) return;

        // Troviamo tutti i video nella slide attiva
        const videos = activeSlide.querySelectorAll('video');
        let activeVideo = null;

        // Capiamo quale video è visibile in base al breakpoint (Desktop o Mobile)
        videos.forEach(video => {
          if (window.getComputedStyle(video).display !== 'none') {
            activeVideo = video;
          }
        });

        if (activeVideo) {
          // 1. Fermiamo temporaneamente l'autoplay a tempo di Swiper
          swiperInstance.autoplay.stop();

          // 2. Fai ripartire il video da zero
          activeVideo.currentTime = 0;
          
          // Gestiamo la promessa del play per evitare errori di blocco del browser
          const playPromise = activeVideo.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.log("Autoplay video intercettato dal browser, passo all'immagine:", error);
              // Se il browser blocca il video, ridiamo il controllo a Swiper (5 secondi)
              swiperInstance.autoplay.start();
            });
          }

          // 3. Rimuoviamo listener passati per evitare trigger multipli
          activeVideo.removeEventListener('ended', activeVideo._slideNextFunc);

          // 4. Quando il video FINISCE, ordiniamo a Swiper di cambiare slide
          activeVideo._slideNextFunc = () => {
            swiperInstance.slideNext();
            // Facciamo ripartire l'autoplay standard per la slide successiva
            swiperInstance.autoplay.start();
          };

          activeVideo.addEventListener('ended', activeVideo._slideNextFunc, { once: true });

        } else {
          // Se è un'immagine, assicuriamoci che l'autoplay standard da 5 secondi sia attivo e resettato
          swiperInstance.params.autoplay.delay = 5000;
          swiperInstance.autoplay.start();
        }
      }
    }
  });

swiperInstance.el.querySelectorAll('.swiper-slide').forEach((slide) => {
  const heading = slide.querySelector('.hero-vp-text');
  
  if (heading && heading.textContent.includes('High performance bras.')) {
    heading.classList.add('custom-highlight-style');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
    $('.testimonial-track').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: true,
        adaptiveHeight: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
    });

  } catch(e) { console.error(e); }
})();
})();
